export const huntPlannerActiveLayerPayload = payload => ({
    type: 'HUNT_PLANNER_ACTIVE_LAYER_PAYLOAD',
    payload: payload
})